import React from 'react';
import SectionHeader from './SectionHeader';
import CommandItem from './CommandItem';

/**
 * Rendert die sektionierte Command-Liste.
 * Empfaengt das flat-sortierte Ergebnis + eine pro-Command-Index-Map,
 * damit der Keyboard-Highlight ueber Sektionen hinweg funktioniert.
 */
export default function CommandList({
  groupedResults,
  sectionsOrder,
  flatResults,
  highlightIndex,
  onSelect,
  onHover,
}) {
  if (!flatResults || flatResults.length === 0) {
    return null; // Empty-State rendert der Parent
  }

  // Index-Map: Command-ID → Position in flatResults (fuer Highlight)
  const indexMap = new Map();
  flatResults.forEach((cmd, i) => indexMap.set(cmd.id, i));

  return (
    <div className="py-1" role="listbox">
      {sectionsOrder.map((section) => {
        const items = groupedResults[section] || [];
        if (items.length === 0) return null;

        return (
          <div key={section} className="mb-1">
            <SectionHeader label={section} count={items.length} />
            <div className="px-1.5">
              {items.map((cmd) => {
                const idx = indexMap.get(cmd.id);
                const isHighlighted = idx === highlightIndex;
                return (
                  <CommandItem
                    key={cmd.id}
                    command={cmd}
                    highlighted={isHighlighted}
                    onSelect={() => onSelect(cmd)}
                    onHover={() => onHover(idx)}
                  />
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
